<template>
  <div id="primary-school-sudents">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container fluid>
      <b-row class="mt-4" align-h="center">
        <b-form-group
          label="Starting Year: "
          label-for="year"
          label-cols-md="auto"
          class="mb-3"
        >
          <b-form-select
            id="year"
            v-model="startYear"
            :options="years"
          ></b-form-select>
        </b-form-group>
      </b-row>
      <b-row>
        <b-col>
          <button @click="downloadXls">Download Form</button>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <div class="table-wrap">
            <br />
            <b-col>
              <h4 class="subtitle">
                Schools's Current Students ({{ schoolStudents.length }})
              </h4>
              <b-form-group>
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-table
              v-cloak
              responsive
              :fields="schoolStudentsFields"
              :items="schoolStudents"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <!-- <template v-slot:cell(first_name)="data"> -->
              <template slot="cell(first_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditStudent',
                    params: { id: row.item.student_uuid }
                  }"
                >
                  <!-- {{data.item.first_name}} {{data.item.last_name}} -->
                  {{ row.item.first_name }} {{ row.item.middle_name }}
                  {{ row.item.last_name }}
                </b-link>
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  class="delete"
                  v-if="isAdmin"
                  @click.stop="deleteSchoolStudent(row.item)"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col>
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col v-if="isAdmin">
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">Add Students</h4>
            <div v-if="showForm">
              <name-search table="students"></name-search>
              <br />
            </div>
            <div v-if="cleanedSearchResults.length">
              <b-col>
                <h6 class="subtitle">
                  Results: {{ cleanedSearchResults.length }} students found
                </h6>
                <b-form-group>
                  <b-input-group>
                    <b-form-input
                      v-model="filterSearchResults"
                      placeholder="Type to Search Results"
                    />
                    <b-input-group-append>
                      <b-btn
                        :disabled="!filterSearchResults"
                        @click="filterSearchResults = ''"
                        >Clear</b-btn
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <div id="alerts" ref="school-students-alert">
                  <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="success"
                    @dismissed="dismissCountDown = 0"
                    @dismiss-count-down="countDownChanged"
                    >You have successfully added a Student!</b-alert
                  >
                  <b-alert
                    :show="dismissCountDownError"
                    dismissible
                    variant="warning"
                    @dismissed="dismissCountDownError = 0"
                    @dismiss-count-down="countDownChangedError"
                  >
                    {{ addStudentErrorMsg }}
                  </b-alert>
                </div>
              </b-col>
              <b-table
                v-cloak
                responsive
                :fields="searchResultsFields"
                :items="cleanedSearchResults"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                small
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filterSearchResults"
                @filtered="onFilteredResults"
              >
                <template slot="cell(student_name)" slot-scope="row">
                  <b-link
                    @click.stop="stopClick"
                    :to="{
                      name: 'EditStudent',
                      params: { id: row.item.student_uuid }
                    }"
                    >{{ row.item.student_name }}</b-link
                  >
                  <br />
                  <p class="small-date">created: {{ row.item.created }}</p>
                </template>
                <template slot="cell(id)" slot-scope="row">
                  <b-link class="add" @click.stop="addStudentToSchool(row)"
                    >ADD</b-link
                  >
                </template>
              </b-table>
              <b-row>
                <b-col>
                  <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- <div v-else>Students are loading...</div> -->
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PrimarySchoolService from "../services/PrimarySchoolService";
import NameSearch from "@/components/NameSearch";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";
import ExcelJS from "exceljs";

export default {
  name: "PrimarySchoolStudents",
  mixins: [flash, scrollTo],
  components: {
    NameSearch
  },
  data() {
    return {
      schoolId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      schoolStudentsFields: [
        { key: "first_name", label: "Name", sortable: true },
        { key: "delete", label: "DELETE" }
      ],
      searchResultsFields: [
        { key: "student_name", label: "Name", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "region", label: "Region", sortable: true },
        { key: "district", label: "District", sortable: true },
        { key: "id", label: "ADD" }
      ],
      file: this.$route.path.slice(1),
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
      totalRows: this.rows,
      students: [],
      showForm: true,
      startYear: new Date().getFullYear(),
      addStudentErrorMsg:
        "Something went wrong. Please refresh and try again, orcontact the site admin."
    };
  },
  methods: {
    ...mapActions({
      GET_SCHOOL_STUDENTS: "primarySchools/GET_SCHOOL_STUDENTS",
      RESET_SCHOOLS_STATE: "primarySchools/RESET_SCHOOLS_STATE",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE"
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    hideForm() {
      this.showForm = !this.showForm;
    },
    toggleForm() {
      this.showForm = !this.showForm;
      this.RESET_SEARCH();
    },
    async updateSchoolTeacher(params) {
      const payload = await {
        id: params.item.id,
        teacher_uuid: params.item.teacher_uuid,
        school_uuid: this.$route.params.id,
        active: !params.item.active
      };
      await SchoolService.updateSchoolTeacher(payload);
      await this.GET_SCHOOL_STUDENTS(this.startYear);
    },
    async deleteSchoolStudent(params) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this student from this school?"
      );
      if (confirmDelete) {
        await PrimarySchoolService.deleteSchoolStudent(params);
        await this.GET_SCHOOL_STUDENTS(this.startYear);
      }
    },
    async addStudentToSchool(params) {
      const payload = await {
        student_uuid: params.item.student_uuid,
        school_uuid: this.$route.params.id,
        start_year: this.startYear
      };

      try {
        const reply = await PrimarySchoolService.addSchoolStudent(payload);
        //console.log("reply: ", reply);
        await this.scrollTo("school-students-alert");
        if (!reply.data.student) {
          this.addStudentErrorMsg = reply.data.message;
          this.flashError();
        } else {
          await this.flashSuccess();
          await this.GET_SCHOOL_STUDENTS(this.startYear);
        }
      } catch (err) {
        this.flashError();
        console.log(err);
      }
    },
    downloadXls() {
      const workbook = new ExcelJS.Workbook();
      workbook.creator = "Perivoli";
      workbook.created = new Date();
      workbook.modified = new Date();

      // create a worksheet with red tab colour
      const worksheet = workbook.addWorksheet(this.school.school_name, {
        properties: {
          tabColor: { argb: 'FF3C6B58' },
          defaultColWidth: 15,
          defaultRowHeight: 45,
        }
      });
      worksheet.pageSetup.printArea = 'A1:P30';
      worksheet.pageSetup.paperSize = 9;
      worksheet.pageSetup.orientation = 'landscape';

      console.log(this.school);

      let location =
        (this.school.district ? this.school.district + ", " : "") +
        (this.school.region ? this.school.region + ", " : "") +
        this.school.country;

      let metaRows = [
        ['', '', '', 'PERIVOLI PUPIL TRACKING (' + this.school.country + ')', '', '', '', '', 'Trainer:'],
        [''], // spacer row
        ['', '', '', 'School name:', this.school.school_name],
        ['', '', '', 'School location:', location],
        ['', '', '', 'No. of ex-Perivoli students:', this.schoolStudents.length],
        ['', '', '', 'Year group (e.g. Year 1):'],
        ['', '', '', 'School year (e.g. 2021 or 2021/2022):'],
        [''], // spacer row
        ['', 'No.', 'Name', 'Gender', 'EMIS no.', 'Date of Birth', 'First language', 'Attendance (%)', 'Dropped out? (Y/N)'],
        ['', '', '', '', '', '', '', '', 'Maths', 'English', 'Art', 'Overall', 'Position in class', 'Number on role'],
      ];
      worksheet.addRows(metaRows);
      worksheet.mergeCells('J9:M9'); // TE "Student's end of year test scores group heading"
      worksheet.mergeCells('N9:O9'); // TE "Performance in Class" group heading

      worksheet.getCell('I3').value = 'Teacher\'s name:';
      worksheet.getCell('I4').value = 'Teacher\'s signature:';
      worksheet.getCell('I6').value = 'Principal / Headteacher\'s name:';
      worksheet.getCell('I7').value = 'Principal / Headteacher\'s signature:';
      worksheet.getCell('N4').value = 'Date:';
      worksheet.getCell('N7').value = 'Date:';
      worksheet.getCell('I6').value = 'Student\'s end of year exam / test results (%)';
      worksheet.getCell('M6').value = 'Performance in class';
      worksheet.getCell('O6').value = 'Held back? (Y/N)';
      worksheet.getCell('P6').value = 'Additional notes';

      worksheet.getColumn('A').width = 5;
      worksheet.getColumn('B').width = 5;
      worksheet.getColumn('C').width = 40;
      worksheet.getColumn('D').width = 10;
      worksheet.getColumn('E').width = 30;
      worksheet.getColumn('F').width = 30;
      worksheet.getColumn('G').width = 30;

      worksheet.getRow(1).height = 100;
      worksheet.getRow(2).height = 25;
      worksheet.getRow(8).height = 25;

      worksheet.getRow(3).font = { size: 18 };
      worksheet.getRow(4).font = { size: 18 };
      worksheet.getRow(5).font = { size: 18 };
      worksheet.getRow(6).font = { size: 18 };
      worksheet.getRow(7).font = { size: 18 };
      worksheet.getColumn('C').font = { size: 18 };
      worksheet.getCell('E3').font = { size: 24 };
      worksheet.getCell('E4').font = { size: 24 };
      worksheet.getCell('E5').font = { size: 24 };
      worksheet.getCell('D1').font = { size: 32 };

      worksheet.getCell('I1').font = { bold: true };
      worksheet.getCell('J1').font = { bold: true };
      worksheet.getCell('E3').font = { bold: true };
      worksheet.getCell('I3').font = { bold: true };
      worksheet.getCell('I6').font = { bold: true };
      worksheet.getCell('N4').font = { bold: true };
      worksheet.getCell('N7').font = { bold: true };
      worksheet.getRow('9').font = { bold: true };
      worksheet.getRow('10').font = { bold: true };
      worksheet.getColumn('C').font = { bold: true };

      // thick border under logo row
      worksheet.getCell('B1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('C1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('D1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('E1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('F1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('G1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('H1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('I1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('J1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('K1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('L1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('M1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('N1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('O1').border = { bottom: { style: 'thick' } };
      worksheet.getCell('P1').border = { bottom: { style: 'thick' } };

      // thin borders under meta cells to fill in
      worksheet.getCell('E6').border = { bottom: { style: 'thin' } };
      worksheet.getCell('F6').border = { bottom: { style: 'thin' } };
      worksheet.getCell('E7').border = { bottom: { style: 'thin' } };
      worksheet.getCell('F7').border = { bottom: { style: 'thin' } };
      worksheet.getCell('J3').border = { bottom: { style: 'thin' } };
      worksheet.getCell('K3').border = { bottom: { style: 'thin' } };
      worksheet.getCell('L3').border = { bottom: { style: 'thin' } };
      worksheet.getCell('M3').border = { bottom: { style: 'thin' } };
      worksheet.getCell('N3').border = { bottom: { style: 'thin' } };
      worksheet.getCell('O3').border = { bottom: { style: 'thin' } };
      worksheet.getCell('P3').border = { bottom: { style: 'thin' } };
      worksheet.getCell('J4').border = { bottom: { style: 'thin' } };
      worksheet.getCell('K4').border = { bottom: { style: 'thin' } };
      worksheet.getCell('L4').border = { bottom: { style: 'thin' } };
      worksheet.getCell('M4').border = { bottom: { style: 'thin' } };
      worksheet.getCell('N4').border = { bottom: { style: 'thin' } };
      worksheet.getCell('O4').border = { bottom: { style: 'thin' } };
      worksheet.getCell('P4').border = { bottom: { style: 'thin' } };
      worksheet.getCell('J6').border = { bottom: { style: 'thin' } };
      worksheet.getCell('K6').border = { bottom: { style: 'thin' } };
      worksheet.getCell('L6').border = { bottom: { style: 'thin' } };
      worksheet.getCell('M6').border = { bottom: { style: 'thin' } };
      worksheet.getCell('N6').border = { bottom: { style: 'thin' } };
      worksheet.getCell('O6').border = { bottom: { style: 'thin' } };
      worksheet.getCell('P6').border = { bottom: { style: 'thin' } };
      worksheet.getCell('J7').border = { bottom: { style: 'thin' } };
      worksheet.getCell('K7').border = { bottom: { style: 'thin' } };
      worksheet.getCell('L7').border = { bottom: { style: 'thin' } };
      worksheet.getCell('M7').border = { bottom: { style: 'thin' } };
      worksheet.getCell('N7').border = { bottom: { style: 'thin' } };
      worksheet.getCell('O7').border = { bottom: { style: 'thin' } };
      worksheet.getCell('P7').border = { bottom: { style: 'thin' } };

      // blue (FF-DCE6F1) background in meta cells to fill in
      worksheet.getCell('E6').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('F6').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('E7').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('F7').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('J3').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('K3').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('L3').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('M3').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('N3').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('O3').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('P3').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('J4').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('K4').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('L4').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('M4').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('N4').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('J6').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('K6').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('L6').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('M6').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('N6').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('O6').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('P6').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('J7').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('K7').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('L7').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('M7').fill = { bgColor: {argb:'FFDCE6F1'} };
      worksheet.getCell('N7').fill = { bgColor: {argb:'FFDCE6F1'} };

      // blue (FF-B8CCE4) background in date cells to fill in
      worksheet.getCell('O4').fill = { bgColor: {argb:'FFB8CCE4'} };
      worksheet.getCell('P4').fill = { bgColor: {argb:'FFB8CCE4'} };
      worksheet.getCell('O7').fill = { bgColor: {argb:'FFB8CCE4'} };
      worksheet.getCell('P7').fill = { bgColor: {argb:'FFB8CCE4'} };

      // grey (FF-F2F2F2) background in DB-provided meta fields
      worksheet.getCell('J1').fill = { bgColor: {argb:'FFF2F2F2'} };
      worksheet.getCell('K1').fill = { bgColor: {argb:'FFF2F2F2'} };
      worksheet.getCell('L1').fill = { bgColor: {argb:'FFF2F2F2'} };
      worksheet.getCell('M1').fill = { bgColor: {argb:'FFF2F2F2'} };
      worksheet.getCell('N1').fill = { bgColor: {argb:'FFF2F2F2'} };
      worksheet.getCell('O1').fill = { bgColor: {argb:'FFF2F2F2'} };
      worksheet.getCell('P1').fill = { bgColor: {argb:'FFF2F2F2'} };

      // grey (FF-F2F2F2) background in DB-provided cells in datarows, example first student only
      worksheet.getCell('C11').fill = { bgColor: {argb:'FFF2F2F2'} };
      worksheet.getCell('D11').fill = { bgColor: {argb:'FFF2F2F2'} };
      worksheet.getCell('F11').fill = { bgColor: {argb:'FFF2F2F2'} };
      worksheet.getCell('C12').fill = { bgColor: {argb:'FFF2F2F2'} };

      // medium borders
      // table corners
      worksheet.getCell('B9').border = {
        left: { style: 'medium' },
        top: { style: 'medium' }
      };
      worksheet.getCell('B10').border = {
        left: { style: 'medium' },
        bottom: { style: 'medium' }
      };
      worksheet.getCell('P9').border = {
        right: { style: 'medium' },
        top: { style: 'medium' }
      };
      worksheet.getCell('P10').border = {
        right: { style: 'medium' },
        bottom: { style: 'medium' }
      };

      // top row - medium top border, thin left border
      worksheet.getCell('C9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('D9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('E9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('F9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('G9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('H9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('I9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('J9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('K9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('L9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('M9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('N9').border = { top: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('O9').border = { top: { style: 'medium' }, left: { style: 'thin' } };

      // bottom row - medium bottom border, thin left border
      worksheet.getCell('C10').border = { bottom: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('D10').border = { bottom: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('E10').border = { bottom: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('F10').border = { bottom: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('G10').border = { bottom: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('H10').border = { bottom: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('I10').border = { bottom: { style: 'medium' }, left: { style: 'thin' } };
      worksheet.getCell('J10').border = { bottom: { style: 'medium' }, left: { style: 'thin' }, top: { style: 'thin' } };
      worksheet.getCell('K10').border = { bottom: { style: 'medium' }, left: { style: 'thin' }, top: { style: 'thin' } };
      worksheet.getCell('L10').border = { bottom: { style: 'medium' }, left: { style: 'thin' }, top: { style: 'thin' } };
      worksheet.getCell('M10').border = { bottom: { style: 'medium' }, left: { style: 'thin' }, top: { style: 'thin' } };
      worksheet.getCell('N10').border = { bottom: { style: 'medium' }, left: { style: 'thin' }, top: { style: 'thin' } };
      worksheet.getCell('O10').border = { bottom: { style: 'medium' }, left: { style: 'thin' }, top: { style: 'thin' } };

      let logoData =
        "data:image/png;base64,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";
      let logoImg = workbook.addImage({
        base64: logoData,
        extension: "png"
      });
      worksheet.addImage(logoImg, {
        tl: { col: 15, row: 1 },
        ext: { width: 210, height: 92 }
      });

      let c = 1;
      let dataRows = this.schoolStudents.map(student => [
        c++,
        `${student.first_name} ${student.last_name}`,
        student.sex,
        student.emis_id,
        student.birthdate.split("T")[0],
        student.languages[0] == "null" ? "" : student.languages[0]
      ]);
      worksheet.addRows(dataRows);

      /* worksheet.mergeCells('D12:P12');
      worksheet.mergeCells('D14:P14');
      worksheet.mergeCells('D16:P16');
      worksheet.mergeCells('D18:P18');
      worksheet.mergeCells('D20:P20');
      worksheet.mergeCells('D22:P22');
      worksheet.mergeCells('D24:P24');
      worksheet.mergeCells('D26:P26');
      worksheet.mergeCells('D28:P28');
      worksheet.mergeCells('D30:P30'); */

      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadworksheetml.worksheet"
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = "perivoli-pupil-tracking.xlsx";
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    },
    stopClick(row) {}
  },
  computed: {
    ...mapGetters({
      getStudentSearchResults: "searches/getStudentSearchResults",
      isAdmin: "auth/isAdmin"
    }),
    years() {
      let years = [];
      let currYear = new Date().getFullYear();
      for (let year = currYear; year > 2000; year--) {
        years.push(year);
      }
      return years;
    },
    schoolStudents: {
      get() {
        return this.$store.state.primarySchools.schoolStudents;
      }
    },
    school: {
      get() {
        return this.$store.state.primarySchools.school;
      }
    },
    cleanedSearchResults() {
      const data = this.getStudentSearchResults.map(k => ({
        id: k.id,
        student_uuid: k.uuid,
        student_name: `${k.first_name} ${k.middle_name} ${k.last_name}`,
        country: k.country,
        region: k.region,
        district: k.district,
        active: k.active,
        created: k.created
      }));
      return data;
    },
    rows() {
      if (this.students.length > 0) {
        return this.students.length;
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.schoolStudentsFields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    }
  },
  watch: {
    // whenever question changes, this function will run
    startYear: function() {
      this.GET_SCHOOL_STUDENTS(this.startYear);
    }
  },
  created() {
    this.RESET_SEARCH();
    this.GET_SCHOOL_STUDENTS(this.startYear);
  }
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}

.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}

.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
